<template>
  <div class="w-100 px-4">
    <div class="d-flex align-items-center justify-content-center">
      <h1>{{title}}</h1>
    </div>
    <div class="w-100 d-flex mb-4" v-for="(data, index) in dataList">
      <div class="d-flex align-items-center justify-content-center" v-if="data.imageShow">
        <img :src="data.image">
      </div>
      <div class="d-flex flex-column justify-content-start flex-fill">
        <h2 class="text-left">{{data.titleH2}}</h2>
        <p class="text-left">{{data.contentP}}</p>
        <div class="d-flex justify-content-start">
          <a class="btn btn-sm btn-outline-primary" :href="data.buttonUrl">{{data.buttonName}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    props: {
      title: {
        type: String
      },
      dataList: {
        type: Array
      }
    },
  };

</script>

<style>

</style>
